'use client';
import { useSession } from '@shared/auth';
import Image from 'next/image';

type ProfileAvatarProps = {
  className?: string;
  'data-track-name': string;
};

function getInitials(fullName: string) {
  return fullName
    .split(' ')
    .map(name => name[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();
}

function ProfileAvatar({ className, ...props }: ProfileAvatarProps) {
  const { session } = useSession();
  const playerProfile = session?.profile;
  const fullName = playerProfile?.firstName + ' ' + playerProfile?.lastName;
  const IMAGE = null;
  return IMAGE ? (
    <Image src={IMAGE} alt={fullName} width={84} height={84} className={`${className} rounded-full`} {...props} />
  ) : (
    <div className={`${className} rounded-full w-20 h-20 bg-container flex items-center justify-center`} {...props}>
      <h3 className="text-foreground">{getInitials(fullName)}</h3>
    </div>
  );
}

export { ProfileAvatar };
